<template>
    <div id="page-content-wrapper" class="admin-content-area">
        <template v-if="user_role == 1">
            <div class="container-fluid xyz">
                <div class="admin-page-content">  
                    <div class="internal-container">
                        <div class="menu-container">

                            <div class="edit-menu-container">
                                <div class="page-title-container">
                                    <div class="page-name">Edit Menu</div>
                                    <div class="pagebutton">
                                        <a href="javascript:void(0)" v-on:click="showAddMenu = !showAddMenu" class="themebutton"><span>Add New Page</span></a>
                                    </div>
                                </div>
                                <div class="edit-menu edit-menu-active" v-show="showAddMenu">
                                    <p>New Menu</p>
                                    <div class="edit-menu-details">
                                        <input type="text" name="title" maxlength="190" v-model="title" placeholder="Menu Name"/>
                                        <div class="help is-danger">{{menu_err_msg}}</div>
                                        <slug-input type="hidden" :value="title" @change="val => slug = val"></slug-input><br/>
                                        <input type="text" v-validate="{url: {require_protocol: true }}" id="new_url" name="new_url" v-model="url" v-show="showMenuUrlField" placeholder="Menu Url"/><br/>
                                        <span v-show="errors.has('new_url')" class="help is-danger">{{ "The URL field is not a valid URL." }}</span>
                                        <div class="help is-danger">{{main_menu_url_err_msg}}</div>
                                        <div class="add-icon-btn">
                                            <template v-if="icon_view != ''">
                                                <span :class="'pull-left menuEditIcon ' + icon_view"></span>
                                            </template>
                                            <a href="javascript:void(0)" v-on:click="selectMainMenuIcon">Select icon</a>
                                        </div>
                                        <div class="page-type-container">
                                            <template v-if="!is_MainMenu_CheckBoxFlag">
                                                <p>Page Type:</p>
                                                <div class="menu-checkbox-container">
                                                    <div class="menu-checkbox" v-bind:key="'feature-'+ feature.id" v-for="feature in features">
                                                        <!-- <template v-if="feature.id <= 2"> -->
                                                        <label class="cb-container">{{ feature.name }}
                                                            <input type="checkbox" name="feature" :class="'feature-type addMenufeature-type addMenuFeatureSelect_' + feature.id" v-bind:key="feature.id" :value="feature.id" v-on:change="areAllSelected(null, feature,'main')" :id="feature.id">
                                                                   <span class="checkmark"></span>
                                                        </label>
                                                        <!-- </template> -->
                                                    </div>
                                                </div>
                                                <template v-if="is_MainMenu_Attachment_CheckBoxFlag == true">
                                                    <p>Allow In Attachment:</p>
                                                    <div class="menu-checkbox-container">
                                                        <div class="menu-checkbox">
                                                            <label class="cb-container">URL
                                                                <input type="checkbox" name="attachment" value="1" :class="'attachment_type addmain_allow_url'" >
                                                                       <span class="checkmark"></span>
                                                            </label>
                                                        </div>
                                                        <div class="menu-checkbox">
                                                            <label class="cb-container">Document
                                                                <input type="checkbox" name="attachment" value="2" :class="'attachment_type addmain_allow_document'" >
                                                                       <span class="checkmark"></span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                </template>
                                            </template>
                                            <div class="sc-btn-container">
                                                <a id="cancel-menu" href="javascript:void(0)" v-on:click="showAddMenu = !showAddMenu" class="themebutton cancelbutton"><span>Cancel</span></a>
                                                <a id="save-menu" href="javascript:void(0)" v-on:click="saveMenu()" class="themebutton"><span>Add New</span></a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <draggable v-model="menuArr" :options="dragOptions" @start="drag=true" @change="onChange">
                                    <div v-for="(element, index) in menuArr" :id="'menu-'+element.id" :key="'menu-'+element.id" class="edit-menu">
                                        <img class="drag-handle" src="/static/images/app-bar-icon.png">
                                        <template v-if="element.menu_title.length >= 18">
                                            <p v-b-tooltip.hover :title="element.menu_title" >{{ stringTrim(element.menu_title,16) }}</p>
                                        </template>
                                        <template v-else>
                                            <p>{{ element.menu_title }}</p>
                                        </template>
                                        <div class="menu-actions">
                                            <a href="javascript:void(0)" id="edit-menu" v-on:click="toggleEditMenu('menu-'+element.id, index)"><img src="/static/images/edit-icon.png"></a>
                                            <template v-if="element.slug != 'calendar-for-training' && element.slug != 'calendar'">
                                                <a href="javascript:void(0)" id="delete-menu" v-on:click="deleteMenu(element.id)"><img src="/static/images/delete-icon.png"></a>
                                            </template>
                                            <template v-else>
                                                <a href="javascript:void(0)" id="delete-menu"><img src="/static/images/delete-icon-dis.png"></a>
                                            </template>
                                        </div>
                                        <div class="edit-menu-details" v-show="checkIfIndexExists(index, false)">
                                            <input type="text" name="title" maxlength="190" v-model="element.menu_title" placeholder="Menu Name"/>
                                            <div class="help is-danger">{{edit_menu_err_msg}}</div>
                                            <slug-input type="hidden" :value="element.menu_title" @change="val => element.slug = val" slug-user-input></slug-input><br/>
                                            <input v-validate="{url: {require_protocol: true }}" id="edit_url" v-show="element.features.length <= 0" type="text" :class="'menuURLCahnge input_url_' + element.id" name="edit_url" v-model="element.url" placeholder="Menu Url"/><br/>
                                            <span v-show="errors.has('edit_url')" class="help is-danger">{{ "The URL field is not a valid URL." }}</span>
                                            <div class="help is-danger">{{main_menu_url_err_msg}}</div>
                                            <div class="add-icon-btn">
                                                <template v-if="icon_view != ''">
                                                    <span :class="'pull-left menuEditIcon ' + icon_view"></span>
                                                </template>
                                                <template v-else>
                                                    <span :class="'pull-left menuEditIcon ' + element.icon_url"></span>
                                                </template>
                                                <a href="javascript:void(0)" v-on:click="selectMainMenuIcon">Edit icon</a>
                                            </div>
                                            <div class="page-type-container">
                                                <template v-if="!is_MainMenu_CheckBoxFlag">
                                                    <template v-if="element.slug != 'calendar-for-training' && element.slug != 'calendar'">
                                                        <p>Page Type: </p>
                                                        <div class="menu-checkbox-container">
                                                            <div class="menu-checkbox" v-bind:key="'feature-'+ feature.id" v-for="feature in features">
                                                                <!-- <template v-if="feature.id <= 2"> -->
                                                                <!-- <input type="checkbox" name="feature" class="feature-type" v-bind:key="feature.id" :value="feature.id" v-on:change="areAllSelected"/> {{ feature.name }} -->
                                                                <label class="cb-container">{{ feature.name }}
                                                                    <input type="checkbox"  name="feature" :class="'feature-type-' + element.id + ' editMenufeature-type-' + element.id + ' hideCheckBox'" v-bind:key="feature.id" :value="feature.id" v-on:change="areAllSelected(element, feature,'main')" :id="element.id+'_'+feature.id" :checked="isFeatureSelected(element, feature.id)">
                                                                           <span class="checkmark"></span>
                                                                </label>
                                                                <!-- <input type="checkbox" name="feature[]" class="feature-type" value="attachments" v-model="checked_features" v-on:change="areAllSelected"/> Attachments -->
                                                                <!-- </template> -->
                                                            </div>
                                                            <!--
                                                            <div class="menu-checkbox">    
                                                                <label class="cb-container">Both
                                                                <input type="checkbox" name="select-all" value="both" v-model="select_all_checked" v-on:change="selectAll">
                                                                <span class="checkmark"></span>
                                                                </label>
                                                            </div>
                                                            -->
                                                        </div>
                                                        <div :id="'attachmnet_div_'+element.id" v-show="element.allow_in_attachment != null">
                                                            <p>Allow In Attachment:</p>
                                                            <div class="menu-checkbox-container">
                                                                <div class="menu-checkbox">
                                                                    <label class="cb-container">URL
                                                                        <input type="checkbox" name="attachment" value="1" :checked="isAttachmentTypeSelected('url',element.allow_in_attachment)" :class="'attachment_type_' + element.id + ' editmain_allow_url'" >
                                                                               <span class="checkmark"></span>
                                                                    </label>
                                                                </div>
                                                                <div class="menu-checkbox">
                                                                    <label class="cb-container">Document
                                                                        <input type="checkbox" name="attachment" value="2" :checked="isAttachmentTypeSelected('attachment',element.allow_in_attachment)" :class="'attachment_type_' + element.id + ' editmain_allow_document'" >
                                                                               <span class="checkmark"></span>
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </template>
                                                </template>
                                                <div class="sc-btn-container">
                                                    <a href="javascript:void(0)" v-on:click="cancelEditMenu(element.id)" class="themebutton cancelbutton"><span>Cancel</span></a>
                                                    <a href="javascript:void(0)" v-on:click="saveMenu(element)" class="themebutton"><span>Update</span></a>
                                                </div>
                                                <a v-if="element.slug != 'calendar-for-training' && element.slug != 'calendar'" href="javascript:void(0)" v-on:click="showSubMenuList(element)" class="add-sub-category">Sub Categories</a>
                                            </div>
                                        </div>
                                        <!-- <label>{{element.id}}</label>{{element.menu_title}}
                                        <button id="delete-menu" type="button" v-on:click="deleteMenu(element.id)" class="btn btn-default">Delete</button> -->
                                    </div>
                                </draggable>

                            </div>

                            <div v-if="selectedMenu != null" id="submenucontainer" class="edit-menu-container sales-programs-container">
                                <div class="page-title-container">
                                    <template v-if="selectedMenu.menu_title.length >= 10">
                                        <div class="page-name" v-b-tooltip.hover :title="selectedMenu.menu_title" >{{ stringTrim(selectedMenu.menu_title,14) }}</div>
                                    </template>
                                    <template v-else>
                                        <div class="page-name" >{{ selectedMenu.menu_title }}</div>
                                    </template>
                                    <div class="pagebutton">
                                        <a href="javascript:void(0)" v-on:click="showAddSubMenu = true" class="plus">+</a>
                                    </div>
                                </div>
                                <div class="edit-menu edit-menu-active" v-show="showAddSubMenu">
                                    <!-- <img src="/static/images/app-bar-icon.png"> -->
                                    <p>New Sub Menu</p>
                                    <div class="menu-actions">
                                    </div>
                                    <div class="edit-menu-details">
                                        <input type="text" name="submenu_title" maxlength="190" v-model="submenu_title" placeholder="Sub Menu Name">
                                        <div class="help is-danger">{{subMenu_err_msg}}</div>
                                        <slug-input type="hidden" :value="submenu_title" @change="val => submenu_slug = val"></slug-input><br/>
                                        <input type="text" v-validate="{url: {require_protocol: true }}" id="sub_menu_url" name="sub_menu_url" v-show="showSubMenuUrlField" v-model="submenu_url" placeholder="Sub Menu Url">
                                        <span v-show="errors.has('sub_menu_url')" class="help is-danger">{{ "The URL field is not a valid URL." }}</span>
                                        <div class="help is-danger">{{sub_menu_url_err_msg}}</div>
                                        <div class="add-icon-btn">
                                            <template v-if="submenu_icon_view != ''">
                                                <span :class="'pull-left menuEditIcon ' + submenu_icon_view"></span>
                                            </template>
                                            <a href="javascript:void(0)" v-on:click="selectSubMenuIcon">Select icon</a>
                                        </div>
                                        <div class="page-type-container">
                                            <template v-if="!is_SubMenu_CheckBoxFlag">
                                                <p>Page Type:</p>
                                                <div class="menu-checkbox-container">
                                                    <div class="menu-checkbox" v-bind:key="'feature-'+ feature.id" v-for="feature in features">
                                                        <!-- <template v-if="feature.id <= 2"> -->
                                                        <!-- <input type="checkbox" name="feature" class="feature-type" v-bind:key="feature.id" :value="feature.id" v-on:change="areAllSelected"/> {{ feature.name }} -->
                                                        <label class="cb-container">{{ feature.name }}
                                                            <input type="checkbox" name="submenu_feature" :class="'subfeaturetype-'+selectedMenu.id + ' subAddfeaturetype-'+selectedMenu.id + ' addSubFeatureSelect_'+ feature.id" v-bind:key="'submenu_'+feature.id" :value="feature.id" v-on:change="areAllSelected(selectedMenu, feature,'sub')">
                                                                   <span class="checkmark"></span>
                                                        </label>
                                                        <!-- </template> -->
                                                    </div>
                                                </div>
                                                <template v-if="is_SubMenu_Attachment_CheckBoxFlag == true">
                                                    <p>Allow In Attachment:</p>
                                                    <div class="menu-checkbox-container">
                                                        <div class="menu-checkbox">
                                                            <label class="cb-container">URL
                                                                <input type="checkbox" name="attachment" value="1" :class="'attachment_sub_type addsub_allow_url'" >
                                                                       <span class="checkmark"></span>
                                                            </label>
                                                        </div>
                                                        <div class="menu-checkbox">
                                                            <label class="cb-container">Document
                                                                <input type="checkbox" name="attachment" value="2" :class="'attachment_sub_type addsub_allow_document'" >
                                                                       <span class="checkmark"></span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                </template>
                                            </template>

                                            <div class="sc-btn-container">
                                                <a href="javascript:void(0)" v-on:click="cancelAddSubMenu()" class="themebutton cancelbutton"><span>Cancel</span></a>
                                                <a href="javascript:void(0)" v-on:click="saveSubMenu()" class="themebutton"><span>Save</span></a>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <draggable v-model="selectedMenu.sub_menu" :options="dragOptionsSubMenu" @start="drag=true" @change="onChangeSubMenu">
                                    <div v-for="(element, index) in selectedMenu.sub_menu" :id="'submenu-'+element.id" :key="'submenu-'+element.id" class="edit-menu edit-sub-menu">
                                        <img class="drag-handle" src="/static/images/app-bar-icon.png">
                                        <template v-if="element.menu_title.length >= 12">
                                            <p v-b-tooltip.hover :title="element.menu_title">{{ stringTrim(element.menu_title,16) }}</p>
                                        </template>
                                        <template v-else>
                                            <p>{{ element.menu_title }}</p>
                                        </template>
                                        <div class="menu-actions">
                                            <a href="javascript:void(0)" id="edit-sub-menu" v-on:click="toggleSubEditMenu('submenu-'+element.id, index)"><img src="/static/images/edit-icon.png"></a>
                                            <template v-if="element.slug != 'calendar-for-training' && element.slug != 'calendar'">
                                                <a href="javascript:void(0)" id="delete-sub-menu" v-on:click="deleteMenu(element.id)"><img src="/static/images/delete-icon.png"></a>
                                            </template>
                                            <template v-else>
                                                <a href="javascript:void(0)" id="delete-sub-menu"><img src="/static/images/delete-icon.png"></a>
                                            </template>
                                        </div>
                                        <div class="edit-menu-details" v-show="checkIfIndexExists(index, true)">
                                            <input type="text" name="submenu_title" maxlength="190" v-model="element.menu_title">
                                            <div class="help is-danger">{{edit_subMenu_err_msg}}</div>
                                            <slug-input type="hidden" :value="element.slug" @change="val => element.slug = val"></slug-input><br/>
                                            <input  v-validate="{url: {require_protocol: true }}" id="editsubmenu_url" v-show="element.features.length <= 0" type="text" :class="'sub_input_url_'+element.id" name="editsubmenu_url" v-model="element.url" placeholder="Sub Menu Url">
                                            <span v-show="errors.has('editsubmenu_url')" class="help is-danger">{{ "The URL field is not a valid URL." }}</span>
                                            <div class="help is-danger">{{sub_menu_url_err_msg}}</div>
                                            <div class="add-icon-btn">
                                                <template v-if="submenu_icon_view != ''">
                                                    <span :class="'pull-left menuEditIcon ' + submenu_icon_view"></span>
                                                </template>
                                                <template v-else>
                                                    <span :class="'pull-left menuEditIcon ' + element.icon_url"></span>
                                                </template>
                                                <a href="javascript:void(0)" v-on:click="selectSubMenuIcon">Edit icon</a>
                                            </div>
                                            <div class="page-type-container">
                                                <template v-if="element.slug != 'calendar-for-training' && element.slug != 'calendar'">                                                    
                                                    <p>Page Type:</p>
                                                    <div class="menu-checkbox-container">
                                                        <div class="menu-checkbox" v-bind:key="'feature-'+ feature.id" v-for="feature in features">
                                                            <!-- <template v-if="feature.id <= 2"> -->
                                                            <!-- <input type="checkbox" name="feature" class="feature-type" v-bind:key="feature.id" :value="feature.id" v-on:change="areAllSelected"/> {{ feature.name }} -->
                                                            <label class="cb-container">{{ feature.name }}
                                                                <input type="checkbox" name="submenu_feature" :class="'subEditfeature-type-'+element.id + ' subfeature-type-'+element.id" v-bind:key="'submenu_'+feature.id" :value="feature.id" v-on:change="areAllSelected(element, feature,'sub')" :id="element.id+'_'+feature.id" :checked="isFeatureSelected(element, feature.id)">
                                                                       <span class="checkmark"></span>
                                                            </label>
                                                            <!-- <input type="checkbox" name="feature[]" class="feature-type" value="attachments" v-model="checked_features" v-on:change="areAllSelected"/> Attachments -->    
                                                            <!-- </template> -->                                                        
                                                        </div>
                                                        <!--
                                                        <div class="menu-checkbox">    
                                                            <label class="cb-container">Both
                                                            <input type="checkbox" name="select-all" value="both" v-model="select_all_checked" v-on:change="selectAll">
                                                            <span class="checkmark"></span>
                                                            </label>
                                                        </div>
                                                        -->
                                                    </div>
                                                    <div :id="'attachmnet_sub_div_'+element.id" v-show="element.allow_in_attachment != null">
                                                        <p>Allow In Attachment:</p>
                                                        <div class="menu-checkbox-container">
                                                            <div class="menu-checkbox">
                                                                <label class="cb-container">URL
                                                                    <input type="checkbox" name="attachment" value="1" :checked="isAttachmentTypeSelected('url',element.allow_in_attachment)" :class="'attachment_sub_type_' + element.id + ' editsub_allow_url'" >
                                                                           <span class="checkmark"></span>
                                                                </label>
                                                            </div>
                                                            <div class="menu-checkbox">
                                                                <label class="cb-container">Document
                                                                    <input type="checkbox" name="attachment" value="2" :checked="isAttachmentTypeSelected('attachment',element.allow_in_attachment)" :class="'attachment_sub_type_' + element.id + ' editsub_allow_document'" >
                                                                           <span class="checkmark"></span>
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </template>
                                                <div class="sc-btn-container">
                                                    <a href="javascript:void(0)" v-on:click="toggleSubEditMenu('submenu-'+element.id, index)" class="themebutton cancelbutton"><span>Cancel</span></a>
                                                    <a href="javascript:void(0)" v-on:click="saveSubMenu(element)" class="themebutton"><span>Update</span></a>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </draggable>
                            </div>
                        </div>
                    </div>                  
                </div>
            </div>
        </template>
        <template v-else-if="user_role == 0">

        </template>
        <template v-else>
            <div class="admin-page-content">
                <div class="col-md-12 error-detail-main forms-container">
                    <div class="error-template">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            We are Sorry!
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <!-- Modal Component -->
        <b-modal size="lg" id="modal1" @cancel="onCancel('main')" ref="myModalRef" hide-footer :hide-header=true>
                 <template v-for="icon in iconArr">
                <span  v-on:click="selectIcon(icon.id,'main',icon.url)" v-bind:key="icon.id" :class="'selectIconModel mainMenuIcon' + icon.id + ' mainIcon spm-nav-menu ' + icon.url"></span>
            </template>
            <div class="clearfix"></div>
            <div class="customIconModelFooter clearfix">
                <button type="button" class="ml-2 btn btn-primary pull-right themebutton" v-on:click="closeMenuIcon">Cancel</button>
                <button type="button" class="ml-2 btn btn-primary pull-right themebutton" v-on:click="closeMenuIcon">OK</button>
            </div>
        </b-modal>
        <b-modal size="lg" id="modal2" @cancel="onCancel('sub')" ref="mySubModalRef" hide-footer :hide-header=true>
                 <template v-for="icon in iconArr">
                <span  v-on:click="selectIcon(icon.id,'sub',icon.url)" v-bind:key="icon.id" :class="'selectIconModel subMenuIcon' + icon.id + ' subIcon spm-nav-menu ' + icon.url"></span>
            </template>
            <div class="clearfix"></div>
            <div class="customIconModelFooter clearfix">
                <button type="button" class="ml-2 btn btn-primary pull-right themebutton" v-on:click="closeSubMenuIcon">Cancel</button>
                <button type="button" class="ml-2 btn btn-primary pull-right themebutton" v-on:click="closeSubMenuIcon">OK</button>
            </div>
        </b-modal>
        <app-footer></app-footer>
    </div>
</template>

<script>

    import Vue from 'vue';
    import Footer from "@/components/partials/Footer";
    import SlugInput from 'vue-slug-input';
    import draggable from 'vuedraggable';
    import {commonMixins} from '../mixins/commonMixins';
    import {HTTP} from '../http-common.js';
    import EventBus from './event-bus';
    import { Validator } from 'vee-validate';

    /*Vue.component("app-footer", Footer);*/
    Vue.use(SlugInput);
//    Vue.use(draggable);

    var self;

    export default {
        name: 'AddEditMenu',
        mixins: [commonMixins],
        components: {
            draggable,
            'app-footer': Footer,
        },
        data() {
            return {
                //user_role: 1,
                title_component: "Edit Menu",
                is_Update: false,
                status: 'active',
                edit_menu_id: 0,
                edit_sub_menu_id: 0,
                menu_id: 0,
                menuSlug: "",
                val: "",
                title: "",
                icon_view: "",
                icon: "",
                slug: "",
                url: "",
                checked_features: [],
                submenu_title: "",
                submenu_icon_view: "",
                submenu_icon: "",
                submenu_slug: "",
                submenu_url: "",
                submenu_checked_features: [],
                select_all_checked: false,
                add_menu_template: "",
                isMenuEditEnabled: [],
                isSubMenuEditEnabled: [],
                showAddMenu: false,
                selectedMenu: null,
                showAddSubMenu: false,
                menuArr: [],
                showMenuUrlField: true,
                showSubMenuUrlField: true,
                iconArr: [],
                menu_err_msg: "",
                main_menu_url_err_msg: "",
                edit_menu_err_msg: "",
                subMenu_err_msg: "",
                edit_subMenu_err_msg: "",
                sub_menu_url_err_msg: "",
                is_MainMenu_CheckBoxFlag: false,
                is_SubMenu_CheckBoxFlag: false,
                is_MainMenu_Attachment_CheckBoxFlag: false,
                is_SubMenu_Attachment_CheckBoxFlag: false,
                loadMainMenu: false,
                loadSubMenu: false,
            }
        },
        watch: {
            menuArr: {
                handler(object) {
                    var self = this;
                    $.each(self.menuArr, function (key, value) {
                        if (self.edit_menu_id == value.id) {
                            if (value.url != "") {
                                self.is_MainMenu_CheckBoxFlag = true;
                            } else {
                                self.is_MainMenu_CheckBoxFlag = false;
                            }
                        }
                    });
                    /*if (object.page_type == 3) {
                     self.loadCalendarEvents();
                     self.loadMeetingType();
                     }*/
                },
                deep: true
            },
            "selectedMenu.sub_menu": {
                handler(object) {
                    var self = this;
                    $.each(self.selectedMenu.sub_menu, function (key, value) {
                        if (self.edit_sub_menu_id == value.id) {
                            if (value.url != "") {
                                self.is_SubMenu_CheckBoxFlag = true;
                            } else {
                                self.is_SubMenu_CheckBoxFlag = false;
                            }
                        }
                    });
                    /*if (object.page_type == 3) {
                     self.loadCalendarEvents();
                     self.loadMeetingType();
                     }*/
                },
                deep: true
            },
            url: function (url, menuArr) {
                if (url != "") {
                    self.is_MainMenu_CheckBoxFlag = true;
                } else {
                    self.is_MainMenu_CheckBoxFlag = false;
                }
            },
            submenu_url: function (submenu_url) {
                if (submenu_url != "") {
                    self.is_SubMenu_CheckBoxFlag = true;
                } else {
                    self.is_SubMenu_CheckBoxFlag = false;
                }
            }
        },
        created: function () {
        },
        beforeMount: function () {
            self = this;
        },
        mounted: function () {
            /* $(document).ready( function(){
             $(".menuURLCahnge").on('keyup', function() {
             //Does some stuff and logs the event to the console
             //$(this).closest(".menuURLCahnge").find('.hideCheckBox').prop('checked', true);
             console.log("Edit Menu");
             alert("adsfas");
             console.log($(this).closest(".menuURLCahnge").find('.hideCheckBox'));
             });
             }); */
            self.getMenuSlug();
            self.getFeatures();
            if (self.menuArr.length == 0) {
                //console.log("Empty Array");
                self.menuArr = JSON.parse(JSON.stringify(self.$store.getters.menuArr));
            }
            self.getIcons();
        },
        methods: {
            //common call methods to get slug and change route in watch and mounted method.
            scrrollToTopMenu: function () {
                $('html,body').animate({
                    scrollTop: $(".edit-menu-container").offset().top
                }, 'slow');
            },
            getMenuSlug: function () {
                var self = this;
                self.menuSlug = this.$route.params.type;
                //console.log(self.menuSlug);
                //self.loadBanner();
            },
            onCancel: function (type) {
                if (type == 'main') {
                    $(".mainIcon").removeClass("selectedIcon");
                    self.icon = self.icon_view = '';
                } else {
                    $(".subIcon").removeClass("selectedIcon");
                    self.submenu_icon = self.submenu_icon_view = '';
                }
            },
            selectIcon: function (id, type, icon) {
                if (type == 'main') {
                    $(".mainIcon").removeClass("selectedIcon");
                    /*if (self.icon != id) {*/
                    $(".mainMenuIcon" + id).addClass("selectedIcon");
                    self.icon = id;
                    self.icon_view = icon;
                    /*} else {
                     self.icon = self.icon_view = '';
                     }*/
                } else {
                    $(".subIcon").removeClass("selectedIcon");
                    if (self.submenu_icon != id) {
                        $(".subMenuIcon" + id).addClass("selectedIcon");
                        self.submenu_icon = id;
                        self.submenu_icon_view = icon;
                    } else {
                        self.submenu_icon = self.submenu_icon_view = '';
                    }
                }
            },
            selectMainMenuIcon: function () {
                //console.log("Function Called");
                this.$refs.myModalRef.show();
            },
            selectSubMenuIcon: function () {
                //console.log("Function Called");
                this.$refs.mySubModalRef.show();
            },
            closeMenuIcon: function () {
                //console.log("Function Called");
                this.$refs.myModalRef.hide();
            },
            closeSubMenuIcon: function () {
                //console.log("Function Called");
                this.$refs.mySubModalRef.hide();
            },
            areAllSelected: function (element, features, menutype) {
                //console.log(features.id);
                //console.log(features);
                //console.log(element);
                if (menutype == 'main') {
                    self.main_menu_url_err_msg = '';
                } else {
                    self.sub_menu_url_err_msg = '';
                }
                var elementID = (element != null) ? element.id + '_' : '';
                if (features != null) {
                    if (features.id == '1' || features.id == '2') {
                        //console.log("if" + elementID);
                        $("#" + elementID + "3").prop("checked", false);
                    } else {
                        //console.log("else : " + elementID);
                        $("#" + elementID + "1").prop("checked", false);
                        $("#" + elementID + "2").prop("checked", false);
                    }
                }

                if ($('.feature-type:checked').length == $('.feature-type').length) {
                    self.select_all_checked = true;
                } else {
                    self.select_all_checked = false;
                }
                self.checked_features = $('.addMenufeature-type:checkbox:checked').map(function () {
                    return $(this).val();
                }).get();
                /*$("input:checkbox[class=feature-type]:checked").map(function () {return $(this).val();}).get();*/
                //console.log(self.checked_features);
                //debugger
                if (element != null) {
                    //console.log("Element No Null");
                    if ($('.subAddfeaturetype-' + element.id + ':checked').length > 0) {
                        console.log("add sub");
                        self.showSubMenuUrlField = false;
                        if (menutype == 'main') {
                            $('.input_url_' + element.id).val('');
                            $('.input_url_' + element.id).hide();
                        }
                    } else {
                        self.showSubMenuUrlField = true;
                        if (menutype == 'main') {
                            $('.input_url_' + element.id).show();
                        }
                    }
                    if ($('.feature-type-' + element.id + ':checked').length > 0) {
                        console.log("add main");
                        if (features.id == 2) {
                            if ($('#' + element.id + "_" + features.id + ':checked').length) {
                                $("#attachmnet_div_" + element.id).show();
                            } else {
                                $("#attachmnet_div_" + element.id).hide();
                            }
                        }
                        if (menutype == 'main') {
                            $('.input_url_' + element.id).val('');
                            $('.input_url_' + element.id).hide();
                        }
                    } else {
                        $("#attachmnet_div_" + element.id).hide();
                        if (menutype == 'main') {
                            $('.input_url_' + element.id).show();
                        }
                    }
                    if ($('.subfeature-type-' + element.id + ':checked').length > 0) {
                        console.log("disable Sub");
                        if (menutype == 'sub') {
                            $('.sub_input_url_' + element.id).val('');
                            $('.sub_input_url_' + element.id).hide();
                        }
                        if (features.id == 2) {
                            if ($('#' + element.id + "_" + features.id + ':checked').length) {
                                $("#attachmnet_sub_div_" + element.id).show();
                            } else {
                                $("#attachmnet_sub_div_" + element.id).hide();
                            }
                        }
                        if (menutype == 'main') {
                            $('.input_url_' + element.id).val('');
                            $('.input_url_' + element.id).hide();
                        }
                    } else {
                        $("#attachmnet_sub_div_" + element.id).hide();
                        console.log("Sub Feature select 0");
                        if (menutype == 'sub') {
                            $('.sub_input_url_' + element.id).show();
                        }
                    }
                    if (features.id == 2) {
                        if ($('.addSubFeatureSelect_' + features.id + ':checked').length) {
                            self.is_SubMenu_Attachment_CheckBoxFlag = true;
                        } else {
                            self.is_SubMenu_Attachment_CheckBoxFlag = false;
                        }
                    }
                } else {
                    if (features.id == 2) {
                        if ($('.addMenuFeatureSelect_' + features.id + ':checked').length) {
                            self.is_MainMenu_Attachment_CheckBoxFlag = true;
                        } else {
                            self.is_MainMenu_Attachment_CheckBoxFlag = false;
                        }
                    }
                    if ($('.feature-type:checked').length > 0) {
                        self.showMenuUrlField = false;
                    } else {
                        self.showMenuUrlField = true;
                    }
                }

            },
            selectAll: function (event) {
                $("input:checkbox[class=feature-type]").prop('checked', self.select_all_checked);
                self.checked_features = $("input:checkbox[class=feature-type]:checked")
                        .map(function () {
                            return $(this).val();
                        })
                        .get();
            },
            formatString: function (data) {
                var value = data.replace(/_/g, " ");
                var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                    return letter.toUpperCase();
                });
                return upp;
            },
            checkIfIndexExists: function (index, isSubMenu) {
                if (isSubMenu) {
                    for (var i = 0; i < this.isSubMenuEditEnabled.length; i++) {
                        if (this.isSubMenuEditEnabled[i] == index) {
                            return true;
                        }
                    }
                    return false;
                } else {
                    for (var i = 0; i < this.isMenuEditEnabled.length; i++) {
                        if (this.isMenuEditEnabled[i] == index) {
                            return true;
                        }
                    }
                    return false;
                }
            },
            isAttachmentTypeSelected: function (type, id) {
                var isChecked = false;
                if (type == 'url') {
                    if (id == 1 || id == 3) {
                        isChecked = true;
                    }
                }
                if (type == 'attachment') {
                    if (id == 2 || id == 3) {
                        isChecked = true;
                    }
                }
                return isChecked;
            },
            isFeatureSelected: function (menu, feature_id) {
                //console.log(JSON.stringify(menu.features) + " " + feature_id);
                var isChecked = false;
                $.each(menu.features, function (key, value) {
                    if (value.id == feature_id) {
                        isChecked = true;
                    }
                });
                if (feature_id == 2 && isChecked) {
                    $("#attachmnet_div_" + menu.id).show();
                } else {
                    $("#attachmnet_div_" + menu.id).hide();
                }
                return isChecked;
            },
            toggleEditMenu: function (id, index) {
                self.edit_menu_id = id.replace('menu-', '');
                if (self.isMenuEditEnabled.length > 0) {
                    if (index == self.isMenuEditEnabled[0]) {
                        $('.edit-menu').removeClass('edit-menu-active');
                        self.isMenuEditEnabled = [];
                    } else {
                        //setting null value to hide currently listed Sub Menu of Previosuly selected Menu.
                        self.selectedMenu = null;
                        self.isSubMenuEditEnabled = [];

                        $('.edit-menu').removeClass('edit-menu-active');
                        $('#' + id).addClass('edit-menu-active');
                        self.isMenuEditEnabled = [];
                        self.isMenuEditEnabled.push(index);
                    }
                } else {
                    $('#' + id).addClass('edit-menu-active');
                    self.isMenuEditEnabled.push(index);
                }
                self.onCancel('main');
            },
            toggleSubEditMenu: function (id, index) {
                //debugger
                self.edit_sub_menu_id = id.replace('submenu-', '');
                if (self.isSubMenuEditEnabled.length > 0) {
                    if (index == self.isSubMenuEditEnabled[0]) {
                        $('.edit-sub-menu').removeClass('edit-menu-active');
                        self.isSubMenuEditEnabled = [];
                    } else {
                        //var currentSelectedId = self.menuArr[self.isSubMenuEditEnabled[0]];
                        $('.edit-sub-menu').removeClass('edit-menu-active');
                        $('#' + id).addClass('edit-menu-active');
                        self.isSubMenuEditEnabled = [];
                        self.isSubMenuEditEnabled.push(index);
                    }
                } else {
                    $('#' + id).addClass('edit-menu-active');
                    self.isSubMenuEditEnabled.push(index);
                }
                self.onCancel('sub');
                self.$store.dispatch('loadMenu');
            },
            cancelEditMenu: function (id, index) {
                $('.edit-menu').removeClass('edit-menu-active');
                self.isMenuEditEnabled = [];
                //setting null value to hide currently listed Sub Menu of Previosuly selected Menu.
                self.selectedMenu = null;
                self.isSubMenuEditEnabled = [];
                self.$store.dispatch('loadMenu');
            },
            onChange: function (event) {
                var fields = {
                    menu_data: self.menuArr
                };

                var config = {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("token")
                    },
                };
                self.showLoader();
                HTTP.post("change_menu_position", fields, config)
                        .then(function (response) {
                            //console.log(response);
                            self.showSAlert(response.data.message, 'success');
                            self.$store.dispatch('loadMenu');
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            self.hideLoader();
                            //console.log(err);
                            self.catchHandler(err, function () {
                            });
                        });
            },
            saveMenu: function (menu) {
                $(".mainIcon").removeClass("selectedIcon");

                var fields = {};
                var error = false;
                var self = this;
                self.menu_err_msg = "";
                self.edit_menu_err_msg = "";
                self.main_menu_url_err_msg = "";
                //console.log("adfsadf" + menu);return false;

                /* if (!self.validateFields(menu)) {
                 console.log("Failed Validation");
                 return;
                 } */
                //return;

                if (menu != null) {

                    if (menu.menu_title == "" || menu.menu_title == null) {
                        self.edit_menu_err_msg = "The Menu Name Field Is Required.";
                        error = true;
                    } else if (menu.menu_title.length > 190) {
                        self.edit_menu_err_msg = "Menu Name Can Not Be Longer then 190 Character.";
                        error = true;
                    }

                    if (menu.url && !self.is_valid_url(menu.url)) {
                        self.main_menu_url_err_msg = "Enter Valid URL.";
                        error = true;
                    }
                    fields = {
                        id: menu.id,
                        menu_title: menu.menu_title,
                        icon_id: (self.icon == '') ? menu.icon_id : self.icon,
                        menu_slug: menu.slug,
                        url: menu.url,
                        feature: self.checked_features = $('.editMenufeature-type-' + menu.id + ':checkbox:checked').map(function () {
                            return $(this).val();
                        }).get(),
                        attachment: $('.attachment_type_' + menu.id + ':checkbox:checked').map(function () {
                            return $(this).val();
                        }).get(),
                        //url : self.url,
                        //feature : self.checked_features,
                    };
                } else {
                    if (self.title == "" || self.title == null) {
                        self.menu_err_msg = "The Menu Name Field Is Required.";
                        error = true;
                    } else if (self.title.length > 190) {
                        self.menu_err_msg = "Menu Name Can Not Be Longer then 190 Character.";
                        error = true;
                    }
                    if (self.url && !self.is_valid_url(self.url)) {
                        self.main_menu_url_err_msg = "Enter Valid URL.";
                        error = true;
                    }
                    fields = {
                        menu_title: self.title,
                        icon_id: self.icon,
                        menu_slug: self.slug,
                        url: self.url,
                        feature: self.checked_features,
                        attachment: $('.attachment_type:checkbox:checked').map(function () {
                            return $(this).val();
                        }).get(),
                    };
                }

                var config = {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("token")
                    },
                };
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        if (!error) {
                            self.showLoader();
                            HTTP.post("add_edit_menu", fields, config)
                                    .then(function (response) {

                                        if (menu != null) {
                                            $('.edit-menu').removeClass('edit-menu-active');
                                            self.isMenuEditEnabled = [];
                                        } else {
                                            self.title = "";
                                            self.slug = "";
                                            self.url = "";
                                            self.icon = self.icon_view = "";
                                            self.select_all_checked = false;
                                            $("input:checkbox[class=feature-type]").prop('checked', self.select_all_checked);
                                            self.showAddMenu = !self.showAddMenu;
                                        }

                                        self.showSAlert(response.data.message, 'success');
                                        self.$store.dispatch('loadMenu');
                                        self.hideLoader();

                                    })
                                    .catch(function (err) {
                                        self.hideLoader();
                                        self.catchHandler(err, function () {

                                        });
                                    });
                        }
                    }
                });

            },
            deleteMenu: function (menu_id) {
                self.$swal.fire({
                    'title': 'Are you sure?',
                    'text': 'You won\'t be able to revert this!',
                    'type': 'warning',
                    'confirmButtonText': 'Yes',
                    'showCancelButton': true,
                }).then((result) => {
                    if (result.value) {
                        self.showLoader();
                        var config = {
                            headers: {
                                Authorization: "Bearer " + localStorage.getItem("token")
                            },
                            data: {
                                id: menu_id,
                            },
                        };

                        HTTP.delete("delete_menu", config)
                                .then(function (response) {
                                    $("#submenu-" + menu_id).remove();
                                    self.$store.dispatch('loadMenu');
                                    self.showSAlert(response.data.message, 'success');
                                    self.hideLoader();
                                })
                                .catch(function (err) {
                                    self.hideLoader();
                                    self.catchHandler(err, function () {});
                                });
                    }
                });

            },
            showSubMenuList: function (menu) {
                self.selectedMenu = menu;
                self.showAddSubMenu = false;
                self.scrrollToTopMenu();

                /*self.$nextTick(()=>{
                 var top = $("#submenucontainer").offset();
                 $('html, body').animate({
                 scrollTop: top
                 }, 1500);
                 });*/
            },
            onChangeSubMenu: function (event) {
                var fields = {
                    menu_data: self.selectedMenu.sub_menu,
                };

                var config = {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("token")
                    },
                };
                self.showLoader();
                HTTP.post("change_menu_position", fields, config)
                        .then(function (response) {
                            //console.log(response);
                            self.showSAlert(response.data.message, 'success');
                            self.$store.dispatch('loadMenu');
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            self.hideLoader();
                            //console.log(err);
                            self.catchHandler(err, function () {
                            });
                        });
            },
            saveSubMenu: function (subMenu) {
                $(".subIcon").removeClass("selectedIcon");
                var fields = {};
                var error = false;
                self.subMenu_err_msg = "";
                self.edit_subMenu_err_msg = "";
                self.sub_menu_url_err_msg = "";

                if (subMenu != null) {

                    if (subMenu.menu_title == "" || subMenu.menu_title == null) {
                        self.edit_subMenu_err_msg = "The Sub Menu Name field is Required.";
                        error = true;
                    } else if (subMenu.menu_title.length > 190) {
                        self.edit_subMenu_err_msg = "Menu Name Can Not Be Longer then 190 Character.";
                        error = true;
                    }
                    if (subMenu.url && !self.is_valid_url(subMenu.url)) {
                        self.sub_menu_url_err_msg = "Enter Valid URL.";
                        error = true;
                    }

                    fields = {
                        id: subMenu.id,
                        menu_title: subMenu.menu_title,
                        menu_slug: subMenu.slug,
                        icon_id: (self.submenu_icon == "") ? subMenu.icon_id : self.submenu_icon,
                        url: subMenu.url,
                        feature: $('.subEditfeature-type-' + subMenu.id + ':checkbox:checked').map(function () {
                            return $(this).val();
                        }).get(),
                        attachment: $('.attachment_sub_type_' + subMenu.id + ':checkbox:checked').map(function () {
                            return $(this).val();
                        }).get(),
                        //url : self.url,
                        //feature : self.checked_features,
                    }
                } else {

                    if (self.submenu_title == "" || self.submenu_title == null) {
                        self.subMenu_err_msg = "The Sub Menu Name field is Required.";
                        error = true;
                    } else if (self.submenu_title.length > 190) {
                        self.subMenu_err_msg = "Menu Name Can Not Be Longer then 190 Character.";
                        error = true;
                    }
                    if (self.submenu_url && !self.is_valid_url(self.submenu_url)) {
                        self.sub_menu_url_err_msg = "Enter Valid URL.";
                        error = true;
                    }
                    var submenu_feature = $('.subAddfeaturetype-' + self.selectedMenu.id + ':checkbox:checked').map(function () {
                        return $(this).val();
                    }).get();
                    fields = {
                        parent_id: self.selectedMenu.id,
                        icon_id: self.submenu_icon,
                        menu_title: self.submenu_title,
                        menu_slug: self.submenu_slug,
                        url: self.submenu_url,
                        feature: submenu_feature,
                        attachment: $('.attachment_sub_type:checkbox:checked').map(function () {
                            return $(this).val();
                        }).get(),
                    };
                }
                //console.log(fields);
                //return;
                var config = {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("token")
                    },
                };
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        if (!error) {

                            self.showLoader();
                            HTTP.post("add_edit_menu", fields, config)
                                    .then(function (response) {

                                        self.submenu_title = "";
                                        self.submenu_icon = self.submenu_icon_view = "";
                                        self.submenu_slug = "";
                                        self.submenu_url = "";
                                        $("input:checkbox[class=feature-type]").prop('checked', self.select_all_checked);
                                        self.showAddSubMenu = !self.showAddSubMenu;
                                        self.showSAlert(response.data.message, 'success');
                                        self.$store.dispatch('loadMenu');
                                        var menuInFocus = self.menuArr[self.isMenuEditEnabled[0]];
                                        self.showSubMenuList(menuInFocus);
                                        self.hideLoader();
                                    })
                                    .catch(function (err) {
                                        self.hideLoader();
                                        self.catchHandler(err, function () {
                                        })
                                    });
                        }
                    }
                });

            },
            cancelAddSubMenu: function () {
                self.showAddSubMenu = false;
                self.submenu_title = "";
                self.submenu_slug = "";
                self.submenu_url = "";
                $("input:checkbox[class=subfeature-type-" + self.selectedMenu.id + "]").prop('checked', self.select_all_checked);
            },
            validateFields: function (element) {
                var isValid = true;

                if (element != null) {
                    return true;
                } else {

                    if (self.title.length == 0) {
                        isValid = false;
                    }

                    if ($('.feature-type:checked').length == 0) {
                        //console.log("Url : ", self.url);
                        if (self.url.length == 0) {
                            isValid = false;
                        }
                    }
                }

                return isValid;
            },
            getIcons: function () {
                var self = this;
                var config = {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("token")
                    },
                };
                self.showLoader();
                HTTP.get("get_icons", config)
                        .then(function (response) {
                            if (response.data.code == 200) {
                                self.iconArr = response.data.content;
                                //console.log(JSON.stringify(self.iconArr[0].url));
                            }
                            self.hideLoader();
                        }).catch(function (err) {
                    self.hideLoader();
                    //console.log(err);
                    self.catchHandler(err, function () {

                    });
                });

            },
            is_valid_url: function (url) {
                var re = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/;
                return re.test(url);
            },
        },
        computed: {
            dragOptions: function () {
                return {
                    group: 'menu',
                    handle: ".drag-handle",
                }
            },
            dragOptionsSubMenu: function () {
                return {
                    group: 'submenu',
                    handle: ".drag-handle",
                }
            },
            /*
             menuArr: {
             get() {
             return this.$store.getters.menuArr;
             },
             set(value) {
             this.$store.commit('changeMenuData', value)
             }
             },
             */
        },
    };

    EventBus.$on('reload-menu', function (menuArr) {
        //console.log('Event Called');
        if (typeof (self) != 'undefined') {
            self.menuArr = JSON.parse(JSON.stringify(menuArr));
            self.$nextTick(() => {
                if (self.isMenuEditEnabled.length > 0) {
                    self.showSubMenuList(self.menuArr[self.isMenuEditEnabled[0]]);
                }
            });
        }
    });
</script>


// WEBPACK FOOTER //
// src/components/AddEditMenu.vue